// {
//   "endpoint": "https://testapi.cloudconnect.ml:8080",
//     "mode": "development" 
// }
export const config = 
{ endpoint: process.env.REACT_APP_PAYPOINT_BACKEND_API_ENDPOINT ?
     process.env.REACT_APP_PAYPOINT_BACKEND_API_ENDPOINT : 
    'https://testapi.cloudconnect.ml' };
